import { render, staticRenderFns } from "./FeeTypeField.vue?vue&type=template&id=40baa43a"
import script from "./FeeTypeField.vue?vue&type=script&lang=js"
export * from "./FeeTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports